import React from "react";
import { Provider } from "react-redux";
import { canUseDOM } from "exenv";

import { initialize } from "../actions";
import graphqlMutationService from "../services/graphqlMutationService";
import graphqlQueryService from "../services/graphqlQueryService";
import configureStore from "./configureStore";

const withInitializationMyActivity = store => Component => {
  class WithInitialization extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        store: canUseDOM
          ? store
          : configureStore({
              graphqlMutationService,
              graphqlQueryService
            })
      };

      this.state.store.dispatch(initialize(props));
    }

    render() {
      return (
        <Provider store={this.state.store}>
          <Component {...this.props} />
        </Provider>
      );
    }
  }

  return WithInitialization;
};

export default withInitializationMyActivity;
